import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import { State } from 'redux/initialState';

import { Society } from 'types';
import { checkPartnerEncumbrancesByDate } from '../api/checkPartnerEncumbrancesByDate';

type UseValidatePartnerEncumbrancesProps = {
  partnerId: string;
  date: Date;
};

export const useValidatePartnerEncumbrances = ({
  partnerId,
  date,
}: UseValidatePartnerEncumbrancesProps) => {
  const actualSociety: Society = useSelector(
    (state: State) => state.society?.actualSociety
  );

  const [hasEncumbrances, setHasEncumbrances] = useState(false);

  const fetchData = useCallback(async () => {
    if (!actualSociety?._id || !partnerId || !date) {
      return;
    }

    try {
      const response = (await store.dispatch(
        checkPartnerEncumbrancesByDate({
          societyId: actualSociety?._id,
          partnerId,
          date,
        })
      )) as { hasEncumbrances: boolean };

      setHasEncumbrances(response?.hasEncumbrances || false);
    } catch (error) {
      console.error(error); // eslint-disable-line no-console
    }
  }, [actualSociety?._id, partnerId, date]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return hasEncumbrances;
};
